<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="title-box">
          <div class="title">智慧健康监测平台</div>
          <div class="time-box">
            <div class="time-box-left"></div>
            <div>
              {{ dateYear }}<span class="time">{{ dateWeek }}</span
              >{{ dateDay }}
            </div>
            <div class="time-box-right"></div>
          </div>
        </div>
        <div class="body-box">
          <div class="body-left">
            <div class="body-left-top">
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon1.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    总床位
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ BedCountNum }}</span>
                  <span class="body-left-top-item-down-text">张</span>
                </div>
              </div>
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon2.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    在床
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ isBedNum }}</span>
                  <span class="body-left-top-item-down-text">人</span>
                </div>
              </div>
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon3.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    今日总告警
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ todayWarningNum }}</span>
                  <span class="body-left-top-item-down-text">次</span>
                </div>
              </div>
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon4.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    未处理
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ NoDeal }}</span>
                  <span class="body-left-top-item-down-text">个</span>
                </div>
              </div>
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon5.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    处理中
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ isDeal }}</span>
                  <span class="body-left-top-item-down-text">个</span>
                </div>
              </div>
              <div class="body-left-top-item">
                <div class="body-left-top-item-up">
                  <img src="../assets/headerIcon6.png" alt="" />
                  <span class="body-left-top-item-up-text">
                    已处理
                  </span>
                </div>
                <div class="body-left-top-item-down">
                  <span>{{ hasDeal }}</span>
                  <span class="body-left-top-item-down-text">个</span>
                </div>
              </div>
            </div>
            <div class="body-left-chart-box">
              <div class="body-left-chart-box-left">
                <div class="body-left-chart-box-left-chart1">
                  <div class="chart-title-box">
                    <img
                      class="chart-title-icon"
                      src="../assets/titleIcon.png"
                      alt=""
                    />
                    <span>24小时状态告警变化</span>
                  </div>
                  <div>
                    <LeftChartOne :cdata="leftChartOneData"></LeftChartOne>
                  </div>
                </div>
                <div class="body-left-chart-box-left-chart2">
                  <div class="chart-title-box">
                    <img
                      class="chart-title-icon"
                      src="../assets/titleIcon.png"
                      alt=""
                    />
                    <span>告警信息</span>
                  </div>
                  <div class="">
                    <LeftChartTwo :list="workOrderList"></LeftChartTwo>
                  </div>
                </div>
              </div>
              <div class="body-left-chart-box-right">
                <div class="body-left-chart-box-left-chart3">
                  <div class="chart-long-title-box">
                    <div>
                      <img
                        class="chart-title-icon"
                        src="../assets/titleIcon.png"
                        alt=""
                      />
                      <span>床位分布图</span>
                    </div>
                    <div class="chart-long-title-icon">
                      <div>
                        <img src="../assets/legend2.png" alt="" />
                        <span>离床</span>
                      </div>
                      <div style="margin:0 20px;">
                        <img src="../assets/legend1.png" alt="" />
                        <span>在床</span>
                      </div>
                      <div>
                        <img src="../assets/legend3.png" alt="" />
                        <span>空床</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <CenterChart :list="centerChartData"></CenterChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="body-right">
            <div class="chart-title-box">
              <img
                class="chart-title-icon"
                src="../assets/titleIcon.png"
                alt=""
              />
              <span>病人体征信息</span>
            </div>
            <div class="body-right-user-box">
              <img
                class="body-right-user-box-avatar"
                :src="
                  user.avatar ? user.avatar : require('../assets/avatar.png')
                "
                alt=""
              />
              <div class="body-right-user-box-info">
                <div class="body-right-user-box-info-top">
                  <div>姓名</div>
                  <div>病床号</div>
                  <div>状态</div>
                </div>
                <div class="body-right-user-box-info-bottom">
                  <div class="body-right-user-box-info-bottom-name">
                    {{ user.name || "-" }}
                  </div>
                  <div>{{ user.bedName || "-" }}</div>
                  <!-- <div>{{ user.status == 1 ? "在床" : "-" }}</div> -->
                  <div>{{ bedStatusMap.get(user.bedStatus) || "-" }}</div>
                </div>
              </div>
            </div>

            <div class="body-right-health">
              <div class="body-right-health-item">
                <div class="body-right-health-item-top">心率</div>
                <div class="body-right-health-item-bottom">
                  <span class="body-right-health-item-bottom-num">
                    {{ bloodData.heartRate }}
                  </span>
                  <span>次/每分钟</span>
                </div>
              </div>
              <div class="body-right-health-item">
                <div class="body-right-health-item-top">呼吸率</div>
                <div class="body-right-health-item-bottom">
                  <span class="body-right-health-item-bottom-num">
                    {{ bloodData.breathRate }}
                  </span>
                  <span>次/每分钟</span>
                </div>
              </div>
              <div class="body-right-health-item">
                <div class="body-right-health-item-top">体温</div>
                <div class="body-right-health-item-bottom">
                  <span class="body-right-health-item-bottom-num">
                    {{ bloodData.temperature }}
                  </span>
                  <span>℃</span>
                </div>
              </div>
              <div class="body-right-health-item">
                <div class="body-right-health-item-top">血压</div>
                <div class="body-right-health-item-bottom">
                  <span class="body-right-health-item-bottom-num">
                    <!-- {{ bloodData.bloodPressureDbp }}/{{
                      bloodData.bloodPressureSbp
                    }} -->
                    {{ bloodData.bloodPressureSbp }}/{{
                      bloodData.bloodPressureDbp
                    }}
                  </span>
                  <span>mmHg</span>
                </div>
              </div>
              <div class="body-right-health-item">
                <div class="body-right-health-item-top">血糖</div>
                <div class="body-right-health-item-bottom">
                  <span class="body-right-health-item-bottom-num">
                    {{ bloodData.bloodSugar }}
                  </span>
                  <span>mmol/L</span>
                </div>
              </div>
            </div>
            <div class="body-right-chart">
              <div class="body-right-chart-title-box">
                <img src="../assets/rightChartIcon1.png" alt="" />
                <span>动态心率</span>
              </div>
              <RightChart :cdata="heartRateData"></RightChart>
            </div>
            <div class="body-right-chart">
              <div class="body-right-chart-title-box">
                <img src="../assets/rightChartIcon2.png" alt="" />
                <span>体温</span>
              </div>
              <RightChart :cdata="temperatureData"></RightChart>
            </div>
            <div class="body-right-chart">
              <div class="body-right-chart-title-box">
                <img src="../assets/rightChartIcon3.png" alt="" />
                <span>呼吸频率</span>
              </div>
              <RightChart :cdata="breathRateData"></RightChart>
            </div>
            <div class="body-right-chart">
              <div class="body-right-chart-title-box">
                <img src="../assets/rightChartIcon4.png" alt="" />
                <span>血压</span>
              </div>
              <RightChartTwo :cdata="spbDbpData"></RightChartTwo>
            </div>
            <div class="body-right-chart">
              <div class="body-right-chart-title-box">
                <img src="../assets/rightChartIcon5.png" alt="" />
                <span>血糖</span>
              </div>
              <RightChart :cdata="bloodSugarData"></RightChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import { formatTime } from "../utils/index.js";
import LeftChartOne from "../components/echart/leftChartOne";
import LeftChartTwo from "../components/echart/leftChartTwo";
import RightChart from "../components/echart/rightChart";
import RightChartTwo from "../components/echart/rightChartTwo";
import CenterChart from "../components/echart/centerChart";
import db from "../utils/localstorage.js";
import mqtt from "mqtt";
import { setTimeout, setInterval } from "timers";

export default {
  mixins: [drawMixin],
  data() {
    return {
      projectId: null,
      timing: null,
      timer: null,
      timeHour: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      decorationColor: ["#568aea", "#000000"],

      BedCountNum: 0,
      isBedNum: 0,
      todayWarningNum: 0,
      NoDeal: 0,
      isDeal: 0,
      hasDeal: 0,
      bloodData: {
        bloodSugar: 0,
        breathRate: 0,
        heartRate: 0,
        temperature: 0,
        bloodPressureDbp: 0,
        bloodPressureSbp: 0,
      },
      workOrderList: [],
      leftChartOneData: {},
      // rightChartData: {},
      bloodSugarData: {},
      breathRateData: {},
      spbDbpData: [],
      heartRateData: {},
      temperatureData: {},

      centerChartData: [],
      userList: [],
      user: {},
      userIndex: 0,

      client: "wss://wss.link-lab.com.cn/mqtt",

      popupInfo: {},
      // bedStatusMap: new Map([
      //   [0, "离床"],
      //   [1, "在床"],
      //   [2, "空闲"],
      //   [3, "未知"],
      // ]),
      bedStatusMap: new Map([
        // [0, "空床"],
        // [1, "在床"],
        // [2, "离床"],
        // [3, "离床"],
        [0, "离床"],
        [1, "在床"],
        [2, "空床"],
        [3, "空床"],
      ]),
    };
  },
  components: {
    LeftChartOne,
    LeftChartTwo,
    RightChart,
    CenterChart,
    RightChartTwo,
  },
  mounted() {
    let key = this.$route.params.projectId;
    db.clear();
    this.$post("/aiot-accountcenter/screen/auth/token", { key }).then((res) => {
      if (res.data.code == 200) {
        db.save("TOKEN_TYPE", res.data.data.token_type);
        db.save("ACCESS_TOKEN", res.data.data.access_token);
        this.projectId = res.data.data.projectId;

        this.timeFn();
        this.cancelLoading();
        this.ajaxFn();
        this.getWorkOrderData();
        this.getUserList(() => {
          this.getBloodData();
          this.getRightChartData();
          this.timeAjax();
        });

        this.timeHourFn();
        this.initMqtt();
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timing);
    clearInterval(this.timer);
    clearInterval(this.timeHour);
  },
  methods: {
    getUniqud() {
      var timestamp = Date.now();
      var randomStr = Math.random()
        .toString(36)
        .substr(2);
      randomStr = randomStr.padEnd(16, "0");
      var uniqueStr = timestamp + randomStr;
      return uniqueStr.substr(0, 16);
    },
    initMqtt() {
      let options = {
        // userName: "admin",
        // password: "public",
        cleanSession: false,
        reconnect: true,
        timeout: 10,
        keepAlive: 60,
        clientId: "ecare_datav_" + this.getUniqud(),
      };
      // 配置
      const client = mqtt.connect(this.client, options);
      // 连接
      client.on("connect", () => {
        console.log("MQTT client connected");
      });
      // 订阅
      client.subscribe("/project/alarm/" + this.projectId, (err) => {
        if (!err) {
          console.log("Subscribed to topic successfully");
        }
      });
      // 接收
      client.on("message", (topic, message) => {
        this.getWorkOrderData();
        // console.log(`Received message on topic ${topic}: ${message}`);
        let list = JSON.parse(JSON.stringify(this.centerChartData));
        let res = JSON.parse(message);
        console.log("res", res);
        let index = list.findIndex((item) => item.id === res.bedId);
        list[index].popupInfo = res;
        // list[index].popupShow = true;
        this.centerChartData = list;
        console.log("list", list);
        this.getLeftChartOneData();
        setTimeout(() => {
          let list = JSON.parse(JSON.stringify(this.centerChartData));
          list[index].popupInfo = {};
          this.centerChartData = list;
        }, 10000);
      });
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    ajaxFn() {
      this.getBedNum();
      this.getWarningNum();
      // this.getWorkOrderData();
      this.getLeftChartOneData();
      this.getCenterChartData();
    },
    timeAjax() {
      this.timer = setInterval(() => {
        this.userIndex++;
        if (this.userIndex > this.userList.length - 1) {
          this.userIndex = 0;
        }
        this.user = this.userList[this.userIndex];

        this.ajaxFn();
        this.getBloodData();
        this.getRightChartData();
      }, 10000);
    },
    timeHourFn() {
      this.timeHour = setInterval(() => {
        this.userIndex = 0;
        this.getUserList();
      }, 60 * 60 * 1000);
    },
    getBedNum() {
      this.$get("/aiot-pmcenter/bed/statistics", {
        projectId: this.projectId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.BedCountNum = res.data.data.totalCount;
          this.isBedNum = res.data.data.inUserCount;
        }
      });
    },
    getWarningNum() {
      this.$get("/aiot-messagecenter/Cockpit/workOrderAlarmsNum", {
        projectId: this.projectId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.todayWarningNum = res.data.data.alarmsNum;
          this.hasDeal = res.data.data.alarmsPocessedNum;
          this.NoDeal = res.data.data.alarmsNotPocessedNum;
          this.isDeal = res.data.data.processingTodayNum;
        }
      });
    },
    getBloodData() {
      this.$get("/aiot-devicecenter/deviceData/comprehensive/data", {
        userId: this.user.id,
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.bloodData = {
            bloodSugar: data.bloodSugar,
            breathRate: data.breathRate,
            heartRate: data.heartRate,
            temperature: data.temperature,
            bloodPressureDbp: data.bloodPressureDbp,
            bloodPressureSbp: data.bloodPressureSbp,
          };

          this.user.bedStatus = data.bedStatus;

          // this.centerChartData = this.centerChartData.map((p) => {
          //   if (p.id == this.user.bedId) {
          //     p.bedStatus = this.user.bedStatus;
          //   }
          //   return p;
          // });
          // console.log("this.user.bedStatus", this.user.bedStatus);
          // console.log("this.centerChartData", this.centerChartData);
        }
      });
    },
    getWorkOrderData() {
      this.$get("/aiot-messagecenter/workOrder", {
        projectId: this.projectId,
        pageNum: 1,
        pageSize: 20,
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.workOrderList = data.records;
        }
      });
    },
    getLeftChartOneData() {
      this.$get("aiot-messagecenter/Cockpit/alarmChange", {
        projectId: this.projectId,
      }).then((r) => {
        if (r.status === 200 && r.data && r.data.data) {
          const data = r.data.data;
          const { notProcessed, processed, totalAlarm, processing } = data;
          this.leftChartOneData = {
            notProcessed,
            processed,
            totalAlarm,
            processing,
          };
        }
      });
    },
    getRightChartData() {
      this.$get("/aiot-devicecenter/deviceData/comprehensive/recent/data", {
        userId: this.user.id,
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          // console.log("rightData", data);
          // this.rightChartData = JSON.parse(JSON.stringify(data));
          this.bloodSugarData = data.bloodSugar;
          this.breathRateData = data.breathRate;
          // this.dbpData = data.dbp;
          this.heartRateData = data.heartRate;
          // this.spbData = data.spb;
          this.temperatureData = data.temperature;
          this.spbDbpData = [data.spb, data.dbp];
        }
      });
    },
    getCenterChartData() {
      this.$get("/aiot-pmcenter/bed/list/detail", {
        projectId: this.projectId,
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data.map((p) => {
            p.popupInfo = {};
            return p;
          });
          this.centerChartData = data;
        }
      });
    },
    getUserList(fun) {
      this.$get("/aiot-accountcenter/member/patient/list", {
        projectId: this.projectId,
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          if (data.length) {
            this.userList = data;
            this.user = data[0];
            typeof fun == "function" && fun();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";
</style>
